import { ComponentType } from '@angular/cdk/portal';
import { abbIconsMapper, materialIcons } from '@components/abb-icon/icons';
import { ICONS } from './icons';
import { URLS } from './urls';
import { OverlayConfig } from '@angular/cdk/overlay';
import { SidePanelData } from '@components/abb-side-panel/side-panel';
import { UsersSidePanelComponent } from '@pages/settings/tabs/users/users-side-panel/users-side-panel.component';
import { GroupsSidePanelComponent } from '@pages/asset-management/groups-side-panel/groups-side-panel.component';
import { AutomationsSidePanelComponent } from '@pages/controls/tabs/automations/automations-side-panel/automations-side-panel.component';
import { AlarmsSidePanelComponent } from '@pages/alarms/alarms-side-panel/alarms-side-panel.component';
import { ContractSidePanelComponent } from '@pages/property-services/tabs/costsTariffs/contract-side-panel/contract-side-panel.component';

type abbIcon = `abb/${keyof (typeof abbIconsMapper)['small']}`;
type matIcon = `mat/${(typeof materialIcons)[number]}`;
type matOutlinedIcon = `mat-outlined/${(typeof materialIcons)[number]}`;
interface ICON {
  name: abbIcon | matIcon | matOutlinedIcon;
  rotateIcon?: boolean;
}
export interface TAB {
  link: string;
  label: string;
  btn?: {
    sidePanel: {
      component: ComponentType<any>;
      data?: any extends SidePanelData<infer TData> ? TData : never;
      options?: Omit<OverlayConfig, 'positionStrategy'>;
    };
    label: string;
  };
}

export interface PAGE {
  icon: ICON;
  title: string;
  link: string;
  tabs?: Array<TAB>;
}

export interface PAGES {
  DASHBOARDS: PAGE;
  PROPERTIES: PAGE;
  ASSETMANAGEMENT: PAGE;
  CONTROLS: PAGE;
  PROPERTYSERVICES: PAGE;
  ALARMS: PAGE;
  REPORTS: PAGE;
  SETTINGS: PAGE;
}

export const PAGES: PAGES = {
  DASHBOARDS: {
    icon: {
      name: `mat-outlined/${ICONS.DASHBOARD}` as matOutlinedIcon,
    },
    title: 'Dashboards',
    link: `${URLS.BASE}${URLS.DASHBOARDS}`,
  },
  PROPERTIES: {
    icon: {
      name: `mat/${ICONS.PROPERTIES}` as matIcon,
    },
    title: 'Properties',
    link: `${URLS.BASE}${URLS.PROPERTIES}`,
  },
  ASSETMANAGEMENT: {
    icon: {
      name: `mat-outlined/${ICONS.ASSETMANAGEMENT}` as matOutlinedIcon,
    },
    title: 'Asset Management',
    link: `${URLS.BASE}${URLS.ASSETMANAGEMENT}`,
    tabs: [
      { link: URLS.DEVICES, label: 'Devices' },

      {
        link: URLS.GROUPS,
        label: 'Groups',
        btn: {
          sidePanel: {
            component: GroupsSidePanelComponent,
            data: { mode: 'new' },
          },
          label: 'New Group',
        },
      },
    ],
  },
  CONTROLS: {
    icon: {
      name: `mat/${ICONS.CONTROLS}` as matIcon,
      rotateIcon: true,
    },
    title: 'Controls',
    link: `${URLS.BASE}${URLS.CONTROLS}`,
    tabs: [
      { link: URLS.MANUALCONTROL, label: 'Manual Control' },
      // {
      //   link: URLS.AUTOMATIONS,
      //   label: 'Automations',
      //   btn: {
      //     sidePanel: {
      //       component: AutomationsSidePanelComponent,
      //       data: { mode: 'new' },
      //     },
      //     label: 'New Automation',
      //   },
      // },
    ],
  },
  PROPERTYSERVICES: {
    icon: {
      name: `mat/${ICONS.PROPERTYSERVICES}` as matIcon,
    },
    title: 'Property Services',
    link: `${URLS.BASE}${URLS.PROPERTYSERVICES}`,
    tabs: [
      { link: URLS.BENCHMARKS, label: 'Benchmarks' },
      { link: URLS.COSTSTARIFFS, label: 'Costs & Tariffs', btn: {
        label: 'Add new contract',
        sidePanel: {component: ContractSidePanelComponent, data: {
          mode: 'new'
        }}
      } },
    ],
  },
  ALARMS: {
    icon: {
      name: `mat/${ICONS.ALARMS}` as matIcon,
    },
    title: 'Alarms',
    link: `${URLS.BASE}${URLS.ALARMS}`,
    tabs: [
      { link: URLS.ALARMSLIST, label: 'Alarms', btn: {
          sidePanel: {
            component: AlarmsSidePanelComponent,
            data: { mode: 'new' },
          },
          label: 'New Alarm',
        },
      },
      { link: URLS.ALARMSLOGS, label: 'Alarms Logs' }
    ]
  },
  REPORTS: {
    icon: {
      name: `mat-outlined/${ICONS.REPORTS}` as matOutlinedIcon,
    },
    title: 'Reports',
    link: `${URLS.BASE}${URLS.REPORTS}`,
  },
  SETTINGS: {
    icon: {
      name: `mat/${ICONS.SETTINGS}` as matIcon,
    },
    title: 'Settings',
    link: `${URLS.BASE}${URLS.SETTINGS}`,
    tabs: [
      { link: URLS.ACCOUNT, label: 'Account' },
      { link: URLS.NOTIFICATIONS, label: 'Notifications' },
      { link: URLS.GENERAL, label: 'General' },
      {
        link: URLS.USERS,
        label: 'Users',
        btn: {
          sidePanel: {
            component: UsersSidePanelComponent,
            data: { mode: 'new' },
          },
          label: 'New User',
        },
      },
      { link: URLS.USERlOGS, label: 'User logs' },
    ],
  },
};
